export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-burst-f6e1c1dae5b38b4fd0c54730d53dfcfc.svg";